import invariant from './invariant';

/**
 * Create a map of action creators from a map of action types.
 * https://redux.js.org/basics/actions#action-creators
 *
 * Values passed to the action creators will be available on the action
 * under the 'payload' property.
 *
 * @param {ActionsTypesMap} actionsTypesMap - A map of action types
 * @return {ActionCreatorsMap} - A map of action creators
 * @example
 *
 * const actions = createActionsCreators({
 *   addUser: 'ADD_USER',
 *   deleteUser: 'DELETE_USER',
 * });
 * actions.addUser({ id: 1 })
 * // → { type: 'ADD_USER', payload: { id: 1 } }
 */
export default function createActionsCreators(actionsTypesMap) {
  invariant(
    actionsTypesMap && typeof actionsTypesMap === 'object',
    'Expected argument "actionsTypesMap" to be of be type "object"',
  );
  const actionCreators = {};
  Object.entries(actionsTypesMap).forEach(([action, type]) => {
    actionCreators[action] = payload => ({ type, payload });
  });
  return actionCreators;
}
